// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
export var composeEventWithValue = function composeEventWithValue(value) {
  return {
    target: {
      value: value
    }
  };
};